import React from 'react';
import CardInfo from 'components/CardInfo';
import Description from 'components/Description';


import mouse from 'images/icons/set-3.png';
import cogs from 'images/icons/set-1.png';
import lock from 'images/icons/set-2.png';
import endataImg from 'images/ENDataTransparent.png';
import endataLogo from 'images/ENData Short Logo.png';
import './About.css';

type AboutUsProps = {
  id: string,
}

const AboutUs: React.FC<AboutUsProps> = ({ id }) => {

  const featureCards = [
    { title: 'DATA CAPTURE', img: mouse, dcp: 'InFocus is an industry-leading communications platform to securely capture high definition audio-visual data in real-time, including GPS location.' },
    { title: 'WEB SOLUTIONS', img: cogs, dcp: 'The InFocus web-based solution is ready at the touch of a button – no app or download to install. This enables our clients to store, manage and access detailed information anytime and anywhere across the globe.' },
    { title: 'DATA SECURITY', img: lock, dcp: 'ENData is certified under the International Organisation for Standardisation (ISO) 27001 (Information Security Management) Global Standard ensuring that your data is securely managed and maintained.' }
  ]

  return (
    <div id={id} className="mt-20">
      <div className="grid grid-cols-1">
        <div className="col-span-1 sm:mx-5  md:mx-10 lg:mx-48">
          <Description img={endataImg} logo={endataLogo} />
        </div>
      </div>
      {/* <div className="grid mt-8 mx-3 grid-cols-1 sm:grid-cols-1 md:grid-cols-2 md:mx-10 lg:grid-cols-2 lg:mx-20  xl:grid-cols-3 lg:mx-56" > */}
      <div className="mt-8 mx-3 md:mx-10 lg:mx-20 xl:mx-56 lg:flex justify-center mt-auto mb-auto">
        {featureCards.map((item, index) => {
          return <CardInfo className="bg-white rounded-lg shadow-lg sm:mx-1 sm:my-1 sm:py-2 md:py-3 md:my-2 md:mx-5 lg:mx-2 lg:py-5 " 
          key={index} title={item.title} img={item.img} dcp={item.dcp} />
        })}
      </div>
    </div>
  )
}

export default AboutUs;